import { TranslateService } from '@ngx-translate/core'

export const createTranslationFn = (
  translateService: TranslateService,
  baseKey: string
) => {
  return (key: string, tokens?: Record<string, any>) =>
    translateService.instant(`${baseKey}${key}`, tokens)
}
